import { safeRetrieve } from './safeStoring';
import { makeToast } from './makeToast';


// Helper for destination key
const getCurrentDateTime = () => {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}${month}${day}_${hours}${minutes}${seconds}`;
};


export const sPushFile = (file, useCaseName) => {
    return new Promise((resolve, reject) => {

        // Step 1: Generate S3 key
        const today = new Date().toISOString().split('T')[0];
        const now = getCurrentDateTime();
        const destinationKey = `${useCaseName}/inputs/${today}/${now}_${file.name}`;

        const apiKey = safeRetrieve('APIKEY_v2');
        const apiUrl = process.env.REACT_APP_API_URL || '';

        // Step 2: Request presigned URL from backend
        fetch(`${apiUrl}/api/dbridge/s3/v1/generate_upload_url`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                api_key: apiKey,
                s3_key: destinationKey,
                content_type: file.type,
            })
        })
        .then((res) => {
            if (!res.ok) {
                return res.json().then(errorData => {
                    console.error('Error getting presigned URL:', errorData);
                    makeToast(`C'è stato un errore durante la preparazione del caricamento. Riprovare o contattare l'amministratore.`, 'warning');
                    resolve(null); // resolve with null on error
                });
            }
            return res.json();
        })
        .then((data) => {
            if (!data || !data.body) {
                makeToast(`La risposta dal server è incompleta. Caricamento non riuscito.`, 'warning');
                resolve(null);
                return;
            }

            // Step 3: Upload to S3 with presigned URL
            fetch(data.body, {
                method: 'PUT',
                headers: { 'Content-Type': file.type },
                body: file,
            })
            .then(uploadRes => {
                if (!uploadRes.ok) {
                    return uploadRes.text().then(errorText => {
                        console.error('S3 upload failed:', errorText);
                        makeToast(`C'è stato un errore nel caricamento del file. Controlla il formato e riprova.`, 'warning');
                        resolve(null);
                    });
                }
                // Success!
                resolve(destinationKey);
            })
            .catch((uploadErr) => {
                console.error('Errore durante upload S3:', uploadErr);
                makeToast(`C'è stato un errore di rete durante il caricamento. Riprovare.`, 'warning');
                resolve(null);
            });
        })
        .catch((err) => {
            console.error('Errore nel processo di generazione URL/upload:', err);
            makeToast(`Errore di rete o server. Riprovare o contattare l'amministratore.`, 'warning');
            resolve(null);
        });
    });
};
